import type { TabulatorFull } from 'tabulator-tables'

let loading: Promise<typeof TabulatorFull> | null = null

// Loads Tabulator in the browser only: since 6.5.3 tabulator-tables touches document when it is
// imported, so a static import breaks server-side rendering of every page that includes a table
export const loadTabulator = () => {
  loading ??= import('tabulator-tables').then((module) => module.TabulatorFull)
  return loading
}
